import React, { useReducer } from 'react';
import ActivitiesContext from './activitiesContext';
import ActivitiesReducer from './activitiesReducer';
import api from '../../../api';

import { TYPES } from '../../types';

const ActivitiesState = (props) => {

    const initialState = {
        feriaCultural: null,
        gozabeque: null,
        musical: null,
        optativas: null,
        fashionShow: null,
        deporte: null,
        clubes: null
    };

    const [state, dispatch] = useReducer(ActivitiesReducer, initialState);

    const getActivities = async () => {
        try {
            const result = await api.get('/actividades');
            dispatch({
                type: TYPES.GET_ACTIVITIES,
                payload: result.data.actividad
            })
        } catch (error) {

        }
    }

    return (
        <ActivitiesContext.Provider
            value={{
                feriaCultural: state.feriaCultural,
                gozabeque: state.gozabeque,
                musical: state.musical,
                optativas: state.optativas,
                fashionShow: state.fashionShow,
                deporte: state.deporte,
                state: state,
                clubes: state.clubes,
                getActivities,
            }}
        >
            {props.children}
        </ActivitiesContext.Provider>
    )
}

export default ActivitiesState;